import IStaffRepository from '../../2_domain/staff/iStaffRepository';
import {
  Staff,
  StaffDto,
  staffDtoFromStaff,
  staffFromDto,
  staffKindToDto,
} from '../../2_domain/staff/staff';
import Connection2 from '../core/connection2';

class StaffRepository implements IStaffRepository {
  //LINK - id 27
  //NOTE - pagination
  getStaffs = async (
    staffKind: StaffKind | 'All',
    searchText: string,
    pagination: Pagination
  ): Promise<PageResult<Staff>> => {
    const res = await Connection2.requestPost('clinic/pass/queryManagerList', {
      category: staffKindToDto(staffKind),
      searchKeyword: searchText,
      // pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
      isAscending: pagination.isAscending,
    });
    return {
      page: res.page,
      list: res.list.map((dto: StaffDto) => staffFromDto(dto)),
    };
  };

  //LINK - id 26
  getStaffKind = async (): Promise<StaffKind[]> => {
    const res = await Connection2.requestGet(
      'clinic/pass/queryManagerCategories'
    );
    const ret: StaffKind[] = [];
    for (const str of Object.values(res)) {
      if (str === 'MANAGER_DOCTOR') {
        ret.push('Doctor');
      } else if (str === 'MANAGER_NURSE') {
        ret.push('Nurse');
      } else if (str === 'MANAGER_NONE') {
        ret.push('Nonmedical Personnel');
      }
    }
    return ret;
  };

  //LINK - id 28
  createStaff = async (staff: Staff): Promise<void> => {
    const staffDto = staffDtoFromStaff(staff);
    await Connection2.requestPost('clinic/pass/createManager', {
      category: staffDto.category,
      name: staffDto.name,
      phone: staffDto.phone,
    });
  };

  //LINK - id 29
  updateStaff = async (staff: Staff): Promise<void> => {
    const staffDto = staffDtoFromStaff(staff);
    await Connection2.requestPatch('clinic/pass/updateManager', {
      id: staffDto.id,
      name: staffDto.name,
      phone: staffDto.phone,
      category: staffDto.category,
    });
  };

  //LINK - id 30
  deleteStaff = async (staffId: number): Promise<void> => {
    await Connection2.requestPatch('clinic/pass/deleteManager', {
      id: staffId,
    });
  };
}

export default StaffRepository;
